<template>
  <div class="content-grid-edit w-full flex items-center justify-center rounded-2">
    <CIcon :color="themeVars.primary4" fa-type="fas" :icon="ComponentIcon.ContentGrid" size="36px" />
  </div>
</template>

<script setup lang="ts">
import CIcon from '@lib/components/CIcon/CIcon.vue'
import useThemeVars from '@lib/composables/useThemeVars'
import { ComponentIcon } from '@canvas-builder/types/canvas'

const themeVars = useThemeVars()
</script>

<style scoped lang="scss">
.content-grid-edit {
  height: 100px;
  background: v-bind('themeVars.primary6');
}
</style>
